import { DragEventHandler, ReactNode } from 'react'
import { DropzoneOptions, useDropzone } from 'react-dropzone'

import { useImagesValidation } from '@/common/form/schema'
import { ChildProps, ClassProps } from '@/common/util/props'

interface DropZoneProps extends ChildProps, ClassProps {
  setFiles(files: File[]): void
  onlyImageFile?: boolean
  clickableChildren?: ReactNode
  onDragEnter?: DragEventHandler<HTMLDivElement>
  onDragLeave?: DragEventHandler<HTMLDivElement>
}

const DropZone = ({
  children,
  clickableChildren = null,
  className,
  setFiles,
  onlyImageFile = false,
  onDragEnter,
  onDragLeave
}: DropZoneProps) => {
  const options: DropzoneOptions = {
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    onDrop: (files) => {
      setFiles(files)
    },
    ...(onlyImageFile && {
      accept: {
        'image/*': []
      }
    })
  }

  const { getRootProps, getInputProps, open } = useDropzone(options)

  return (
    <div
      {...getRootProps({ className: className })}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onMouseLeave={onDragLeave}
    >
      <input {...getInputProps()} />
      {children}
      {clickableChildren && (
        <label htmlFor='attach-file' onClick={open}>
          {clickableChildren}
        </label>
      )}
    </div>
  )
}

interface FileFieldDrops extends ChildProps, ClassProps {
  onUploadFiles(files: File[]): void
  onlyImageFile?: boolean
  onDragEnter?: DragEventHandler<HTMLDivElement>
  onDragLeave?: DragEventHandler<HTMLDivElement>
}

const FormDropZone = ({
  children,
  className,
  onUploadFiles,
  onlyImageFile = false,
  onDragEnter,
  onDragLeave
}: FileFieldDrops) => {
  const { validate } = useImagesValidation()

  const handleChange = (files: File[]) => {
    if (files.length > 0 && (!onlyImageFile || validate(files))) {
      onUploadFiles(files)
    }
  }

  return (
    <>
      <DropZone
        className={className}
        setFiles={handleChange}
        onlyImageFile={onlyImageFile}
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
      >
        {children}
      </DropZone>
    </>
  )
}

export default FormDropZone
